<ng-container [ngSwitch]="type">
  <span
    *ngSwitchCase="trafficType.PRODUCT"
    [inlineSVG]="ICON_PRODUCT"
    class="svg-icon svg-icon-2x"
    test-id="traffic-type.product"
  >
  </span>

  <span
    *ngSwitchCase="trafficType.BANNER"
    [inlineSVG]="ICON_BANNER"
    class="svg-icon svg-icon-2x"
    test-id="traffic-type.banner"
  >
  </span>
</ng-container>
